module.exports = __webpack_public_path__ + "static/media/page-number-star.71f4d533.png";